import React, { useState, useEffect } from 'react';
import { db } from '../../config/firebase';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Shared/Sidebar';

export default function Students() {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStudents();
  }, []);

  async function fetchStudents() {
    try {
      const snap = await getDocs(collection(db, 'students'));
      setStudents(
        snap.docs.map(d => ({ id: d.id, ...d.data() }))
      );
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  async function handleDelete(id) {
    if (window.confirm(
      'Are you sure you want to remove this student?'
    )) {
      await deleteDoc(doc(db, 'students', id));
      fetchStudents();
    }
  }

  const filtered = students.filter(s =>
    `${s.firstName} ${s.lastName} ${s.studentId} ${s.school} ${s.class}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.main}>

        <div style={styles.pageHeader}>
          <div>
            <div style={styles.pageTitle}>Students</div>
            <div style={styles.pageSub}>
              All enrolled students in the program
            </div>
          </div>
          <button
            style={styles.btnPrimary}
            onClick={() => navigate('/staff/add-student')}
          >
            + Add Student
          </button>
        </div>

        {/* SEARCH */}
        <div style={styles.searchBar}>
          <span style={styles.searchIcon}></span>
          <input
            style={styles.searchInput}
            placeholder="Search by name, ID, school or class..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {/* STATS ROW */}
        <div style={styles.statsRow}>
          <div style={styles.statPill}>
            <div style={{
              ...styles.statPillNum, color: '#14452F'
            }}>
              {students.length}
            </div>
            <div style={styles.statPillLabel}>
              Total Students
            </div>
          </div>

          {[...new Set(students.map(s => s.class))]
            .sort((a, b) => Number(a) - Number(b))
            .map((cls, i) => (
              <div key={i} style={styles.statPill}>
                <div style={{
                  ...styles.statPillNum, color: '#E65100'
                }}>
                  {students.filter(s => s.class === cls).length}
                </div>
                <div style={styles.statPillLabel}>
                  Class {cls}
                </div>
              </div>
            ))}

          <div style={styles.statPill}>
            <div style={{
              ...styles.statPillNum, color: '#C62828'
            }}>
              {students.filter(s =>
                s.hasBirthCertificate === 'no'
              ).length}
            </div>
            <div style={styles.statPillLabel}>
              Need Certificate
            </div>
          </div>
        </div>

        {/* STUDENT LIST */}
        <div style={styles.panel}>
          {loading ? (
            <div style={styles.empty}>
              Loading students...
            </div>
          ) : filtered.length === 0 ? (
            <div style={styles.empty}>
              {search
                ? 'No students match your search.'
                : 'No students yet. Add your first student!'}
            </div>
          ) : (
            filtered.map((s) => (
              <div key={s.id} style={styles.studentRow}>

                {/* AVATAR */}
                <div style={styles.avatar}>
                  {s.photoURL ? (
                    <img
                      src={s.photoURL}
                      alt={s.firstName}
                      style={styles.avatarImg}
                    />
                  ) : (
                    <span>
                      {s.firstName?.[0]}{s.lastName?.[0]}
                    </span>
                  )}
                </div>

                {/* INFO */}
                <div style={styles.studentInfo}>
                  <div style={styles.studentName}>
                    {s.firstName} {s.lastName}
                  </div>
                  <div style={styles.studentMeta}>
                    🪪 {s.studentId} · {s.school} ·
                    Class {s.class} · {s.region}
                  </div>
                  <div style={styles.studentMeta}>
                    ‍{s.teacherName || 'No teacher'} ·
                    {s.healthStatus || 'Unknown'}
                  </div>
                </div>

                {/* SUPPORT BADGES */}
                <div style={styles.supportBadges}>
                  {s.support?.schoolFees &&
                    <span style={styles.badgeGreen}>
                      Fees
                    </span>}
                  {s.support?.uniform &&
                    <span style={styles.badgeGreen}>
                      👕 Uniform
                    </span>}
                  {s.support?.food &&
                    <span style={styles.badgeGreen}>
                      Food
                    </span>}
                  {s.support?.stationery &&
                    <span style={styles.badgeGreen}>
                      🎒 Stationery
                    </span>}
                </div>

                {/* CERT BADGE */}
                <span style={{
                  ...styles.certBadge,
                  background:
                    s.hasBirthCertificate === 'yes'
                      ? '#EAF3EC'
                      : s.hasBirthCertificate === 'processing'
                      ? '#FFF3E0'
                      : '#FFEBEE',
                  color:
                    s.hasBirthCertificate === 'yes'
                      ? '#14452F'
                      : s.hasBirthCertificate === 'processing'
                      ? '#E65100'
                      : '#C62828',
                }}>
                  {s.hasBirthCertificate === 'yes'
                    ? 'Has Cert'
                    : s.hasBirthCertificate === 'processing'
                    ? 'Processing'
                    : 'No Cert'}
                </span>

                {/* STATUS */}
                <span style={styles.statusBadge}>
                  {s.status || 'Active'}
                </span>

                {/* ACTIONS */}
                <div style={styles.actions}>
                  <button
                    style={styles.btnEdit}
                    onClick={() => navigate(
                      `/edit-student/${s.id}`
                    )}
                  >
                    Edit
                  </button>
                  <button
                    style={styles.btnDelete}
                    onClick={() => handleDelete(s.id)}
                  >
                    Futa
                  </button>
                </div>

              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
}

const styles = {
  layout: {
    display: 'flex',
    minHeight: '100vh',
    background: '#F6F4EE',
  },
  main: {
    flex: 1,
    padding: '26px',
    overflowY: 'auto',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '14px',
  },
  pageTitle: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '25px',
    background: 'linear-gradient(135deg, #14452F, #1F6B45)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  pageSub: {
    fontSize: '12.5px',
    color: '#6B7280',
    marginTop: '3px',
  },
  btnPrimary: {
    background: 'linear-gradient(135deg, #F57C00, #FFA726)',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '10px',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(245,124,0,0.25)',
  },
  searchBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: '#fff',
    borderRadius: '12px',
    padding: '10px 16px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  searchIcon: { fontSize: '16px' },
  searchInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '13.5px',
    fontFamily: 'inherit',
    background: 'transparent',
    color: '#1C1C1E',
  },
  statsRow: {
    display: 'flex',
    gap: '12px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  statPill: {
    background: '#fff',
    borderRadius: '12px',
    padding: '12px 18px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    border: '1px solid rgba(0,0,0,0.04)',
    textAlign: 'center',
    minWidth: '80px',
  },
  statPillNum: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '22px',
    fontWeight: '700',
  },
  statPillLabel: {
    fontSize: '11px',
    color: '#6B7280',
    marginTop: '2px',
  },
  panel: {
    background: '#fff',
    borderRadius: '16px',
    padding: '8px 20px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  empty: {
    textAlign: 'center',
    color: '#6B7280',
    fontSize: '13px',
    padding: '30px 0',
  },
  studentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '14px 0',
    borderBottom: '1px solid #F3F4F6',
    flexWrap: 'wrap',
  },
  avatar: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #14452F, #1F6B45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    flexShrink: 0,
    overflow: 'hidden',
  },
  avatarImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  studentInfo: { flex: 1, minWidth: '200px' },
  studentName: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '3px',
  },
  studentMeta: {
    fontSize: '11.5px',
    color: '#6B7280',
    marginTop: '2px',
    lineHeight: 1.5,
  },
  supportBadges: {
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap',
  },
  badgeGreen: {
    fontSize: '10.5px',
    padding: '3px 8px',
    borderRadius: '20px',
    background: '#EAF3EC',
    color: '#14452F',
    fontWeight: '500',
  },
  certBadge: {
    fontSize: '10.5px',
    padding: '4px 10px',
    borderRadius: '20px',
    fontWeight: '500',
    flexShrink: 0,
  },
  statusBadge: {
    fontSize: '10.5px',
    padding: '4px 10px',
    borderRadius: '20px',
    background: '#EAF3EC',
    color: '#14452F',
    fontWeight: '600',
    flexShrink: 0,
  },
  actions: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  btnEdit: {
    background: 'linear-gradient(135deg, #14452F, #1F6B45)',
    color: '#fff',
    border: 'none',
    padding: '7px 14px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  btnDelete: {
    background: '#FFEBEE',
    color: '#C62828',
    border: 'none',
    padding: '7px 10px',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};